export default __webpack_public_path__ + "static/media/text-bnb.c3e18522.svg";